import { Box, Divider, Flex, FormLabel, Link, Text } from "@chakra-ui/react";

import { ExportFlagsmithForm } from "@/integration/components/flagsmith/ExportFlagsmithForm";
import { ImportLaunchDarklyForm } from "@/integration/components/launch-darkly/ImportLaunchDarklyForm";
import { useFlag } from "@reflag/react-sdk";

export function ImportTools() {
  const { isEnabled: launchDarklyImportEnabled } = useFlag(
    "launchdarkly-import",
  );
  const { isEnabled: flagsmithExportEnabled } = useFlag("flagsmith-export");
  const anyToolEnabled = launchDarklyImportEnabled || flagsmithExportEnabled;

  return (
    <Flex direction="column" gap={6} maxW="mediumForm">
      {launchDarklyImportEnabled && <ImportLaunchDarklyForm />}
      {launchDarklyImportEnabled && flagsmithExportEnabled && <Divider />}
      {flagsmithExportEnabled && <ExportFlagsmithForm />}
      {anyToolEnabled && (
        <>
          <Divider />
          <Box>
            <FormLabel pb={1}>Import from other systems</FormLabel>
            <Text color="dimmed" fontSize="sm" mb={4}>
              Reach out to us at{" "}
              <Link href="mailto:hello@reflag.com">hello@reflag.com</Link> to
              import flags from other systems.
            </Text>
          </Box>
        </>
      )}
    </Flex>
  );
}
